import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "y7iq2wpp",
  dataset: "production",
});
